import React from 'react';
import { FaCheckCircle, FaCircle } from 'react-icons/fa';

const CheckoutSteps = ({ currentStep }) => {
  const steps = [
    { id: 1, name: 'Address', completed: currentStep >= 1 },
    { id: 2, name: 'Delivery', completed: currentStep >= 2 },
    { id: 3, name: 'Payment', completed: currentStep >= 3 },
    { id: 4, name: 'Review', completed: currentStep >= 4 }
  ];

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between max-w-4xl mx-auto">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            {/* Step Circle */}
            <div className="flex flex-col items-center flex-1">
              <div className={`relative flex items-center justify-center w-10 h-10 rounded-full transition-all duration-300 ${
                step.completed 
                  ? 'bg-green-500 text-white' 
                  : currentStep === step.id 
                    ? 'bg-orange-500 text-white ring-4 ring-orange-200' 
                    : 'bg-gray-200 text-gray-400'
              }`}>
                {step.completed ? (
                  <FaCheckCircle className="text-lg" />
                ) : (
                  <FaCircle className="text-xs" />
                )}
              </div>
              <p className={`mt-2 text-xs sm:text-sm font-medium transition-colors ${
                step.completed || currentStep === step.id 
                  ? 'text-gray-800' 
                  : 'text-gray-400'
              }`}>
                {step.name}
              </p>
            </div>

            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div className={`h-1 flex-1 mx-2 transition-all duration-300 ${
                step.completed ? 'bg-green-500' : 'bg-gray-200'
              }`} />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default CheckoutSteps;
